module.exports = __webpack_public_path__ + "img/Stop_War_HD 2_00076.396cf5de.png";